import { render, staticRenderFns } from "./PazienteProgetti.vue?vue&type=template&id=5ff50587&scoped=true"
import script from "./PazienteProgetti.vue?vue&type=script&lang=js"
export * from "./PazienteProgetti.vue?vue&type=script&lang=js"
import style0 from "./PazienteProgetti.vue?vue&type=style&index=0&id=5ff50587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff50587",
  null
  
)

export default component.exports